import * as React from 'react';
import { Brands } from './brands/brands';
import { BRANDS_LIST_PATH_NAME, BRANDS_PATH_NAME } from '../common';

export type Route = {
  key: React.Key;
  component?: React.ElementType;
  path: string | string[];
  exact?: boolean;
  strict?: boolean;
  routes?: Route[];
};
export type RootRoute = Route & {
  routes: Route[];
};

export const routes: RootRoute[] = [
  {
    key: 'StoreList',
    component: Brands,
    path: [`/${BRANDS_LIST_PATH_NAME}`, `/${BRANDS_PATH_NAME}`],
    exact: true,
    strict: false,
    routes: [],
  },
];
